import React from 'react';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';

interface TermsProps {
  onNavigate: (screen: string) => void;
}

const Terms: React.FC<TermsProps> = ({ onNavigate }) => {
  return (
    <div className="container">
      <SharedHeaderHomeowner onNavigate={onNavigate} />
      <div className="content" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', fontSize: '36px', fontWeight: '700', color: '#1f2937' }}>
          CoreBids Terms & Conditions
        </h1>
        
        <div style={{ 
          background: '#ffffff', 
          padding: '40px', 
          borderRadius: '12px', 
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          lineHeight: '1.6',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            <strong>Last Updated:</strong> March 15, 2026
          </p>
          
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            CoreBids, Inc. ("we," "our," or "us") values your privacy and is committed to protecting your personal information. We collect only the information necessary to provide our services, such as your name, contact details, property information, project preferences, and communication preferences. This information is used solely for communication purposes, service delivery, contractor matching, and improving customer experience, as further detailed in our Privacy Policy.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            1. Scope of Services
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids provides services, including roofing estimation and contractor matching, subject to availability and compliance with applicable laws. Quotes or proposals are estimates and may be adjusted based on project scope or unforeseen circumstances.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            2. User Responsibilities
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By using our website or services, you agree to provide accurate information and refrain from any activities that may disrupt or harm the website, its users, or operations. You must also adhere to any policies or guidelines outlined during your engagement with CoreBids.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            3. Intellectual Property
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            All content on this website, including text, images, logos, and designs, is the property of CoreBids or its licensors. Unauthorized use, reproduction, or distribution is prohibited.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            4. Payment Terms
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Clients must adhere to agreed-upon payment schedules for services. Any changes to payment terms will be communicated in writing. Failure to comply may result in delays or cessation of services.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            5. Messaging Terms & Conditions
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By providing your phone number or email address, you agree to these Terms & Conditions, our Messaging Terms & Conditions, and our Privacy Policy. You consent to receive messages from CoreBids, including SMS, MMS, email, and other electronic communications. Mobile opt-in information is never shared with third parties.
          </p>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            5a. SMS Terms
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By providing your phone number, you agree to receive SMS messages from CoreBids related to:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Account notifications</li>
            <li style={{ marginBottom: '8px' }}>Appointment notifications</li>
            <li style={{ marginBottom: '8px' }}>Customer care</li>
            <li style={{ marginBottom: '8px' }}>Promotions and marketing inquiries</li>
            <li style={{ marginBottom: '8px' }}>Orders and ongoing projects</li>
          </ul>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Message frequency may vary based on engagement. You may receive up to 4 marketing messages per month. Message and data rates may apply. Consent is not a condition of purchase.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            To unsubscribe, reply STOP or CANCEL. After unsubscribing, you will receive a confirmation SMS, and your number will be removed from our list within 24 hours. For assistance, reply HELP.
          </p>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            5b. Email Terms
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By providing your email, you agree to receive communications from CoreBids, including:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Business or project updates</li>
            <li style={{ marginBottom: '8px' }}>Service notifications</li>
            <li style={{ marginBottom: '8px' }}>Payment and invoicing</li>
            <li style={{ marginBottom: '8px' }}>Promotional materials and event invitations</li>
          </ul>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            You may unsubscribe at any time via the unsubscribe link. Opting out of marketing emails does not affect communications required for ongoing projects.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We strive for accuracy in email communications but are not liable for errors or omissions. Emails are the property of CoreBids and intended solely for the recipient. Unauthorized use, disclosure, copying, or distribution is prohibited.
          </p>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            5c. Privacy and Security
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Mobile opt-in and email subscription information are never shared with third parties. Personal information is handled per our Privacy Policy. We take reasonable measures to secure communications but cannot guarantee absolute security.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            6. Privacy Policy Highlights
          </h2>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            Information We Collect:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}><strong>Personal information:</strong> Name, contact details, property information, project requirements, and preferences.</li>
            <li style={{ marginBottom: '8px' }}><strong>Usage information:</strong> Device data, IP address, usage patterns, cookies, and similar technologies.</li>
          </ul>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            How We Use Your Information:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Provide and improve services</li>
            <li style={{ marginBottom: '8px' }}>Match you with contractors</li>
            <li style={{ marginBottom: '8px' }}>Send project updates and notifications</li>
            <li style={{ marginBottom: '8px' }}>Provide customer support</li>
            <li style={{ marginBottom: '8px' }}>Send marketing communications with consent</li>
          </ul>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            Information Sharing:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>With contractors to facilitate projects</li>
            <li style={{ marginBottom: '8px' }}>With service providers to operate the platform</li>
            <li style={{ marginBottom: '8px' }}>When required by law or to protect rights</li>
          </ul>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            Your Rights:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Access and update personal information</li>
            <li style={{ marginBottom: '8px' }}>Opt-out of marketing communications</li>
            <li style={{ marginBottom: '8px' }}>Request deletion of data</li>
            <li style={{ marginBottom: '8px' }}>Control cookie preferences</li>
          </ul>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>Data Security:</strong> Appropriate measures are taken to protect personal information, but no method is 100% secure.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>Data Retention:</strong> Personal information is retained as long as necessary to provide services and fulfill legal requirements.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>Children's Privacy:</strong> We do not knowingly collect information from children under 13.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>Changes to Policy:</strong> Updates are posted on this page with an updated "Last Updated" date.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            7. Limitation of Liability
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids is not liable for indirect, incidental, or consequential damages arising from website or service use, except as explicitly stated in contractual agreements.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            8. Termination
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids reserves the right to suspend or terminate access to services or the website for violations of these Terms & Conditions or applicable laws.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            9. Modifications
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We may update these Terms & Conditions from time to time. Changes will be posted on this page, and continued use of the website constitutes acceptance of the updated terms.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            10. Governing Law
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            These Terms & Conditions are governed by the laws of Tennessee, United States. Any disputes will be resolved through local courts.
          </p>
          
          <div style={{ 
            background: '#f3f4f6', 
            padding: '20px', 
            borderRadius: '8px', 
            marginTop: '16px',
            border: '1px solid #e5e7eb'
          }}>
            <p style={{ margin: '0', fontSize: '16px' }}>
              <strong>Contact Information:</strong><br />
              Email: info@corebids.com
            </p>
          </div>
        </div>
    </div>
  </div>
);
};

export default Terms; 